import { render, staticRenderFns } from "./CoursesModal.vue?vue&type=template&id=64b8aba6&scoped=true&"
import script from "./CoursesModal.vue?vue&type=script&lang=js&"
export * from "./CoursesModal.vue?vue&type=script&lang=js&"
import style0 from "./CoursesModal.vue?vue&type=style&index=0&id=64b8aba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8aba6",
  null
  
)

export default component.exports